module.exports = __webpack_public_path__ + "img/pr-2.ee10d1ad.png";